import { render, staticRenderFns } from "./checkURL.vue?vue&type=template&id=9ca4ac66&"
import script from "./checkURL.vue?vue&type=script&lang=js&"
export * from "./checkURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports